/* eslint-disable vue/require-default-prop */
<template>
  <div
    class="app-container"
    style="padding:0"
  >
    <el-table
      :data="tableData"
      border
      :header-cell-style="{background:theme()}"
      style="width: 100%"
      :class="{'gray-color':isGray}"
      :height="tableCustomHeight"
      :show-summary="showSummary"
      :summary-method="summaryMethod"
      :span-method="spanMethod"
    >
      <el-table-column
        label="序号"
        align="center"
        type="index"
        width="55"
        row-style="background:red"
      />
      <el-table-column
        v-for="(column, index) in tableColumns"
        :key="index"
        resizable
        :fixed="column.fixed ? column.fixed : false"
        :width="column.width ? column.width : 'auto'"
        show-overflow-tooltip
        :label="column.label"
        :prop="column.prop"
        :header-align="column.headerAlign"
        :align="column.textAlign"
      >
        <template slot-scope="scope">
          <span v-if="column.isImage && scope.row[column.prop]">
            <img
              v-for="(imgSrc, imgIndex) in scope.row[column.prop]"
              :key="imgIndex"
              :src="imgSrc"
              class="img-size"
              @click="showImage(imgIndex,scope.row[column.prop])"
            >
          </span>
          <span
            v-else-if="column.isLink"
            class="link"
            @click="handleLink(scope.row)"
          >
            {{ scope.row[column.prop] }}
          </span>
          <span
            v-else-if="column.isCustomLink"
            class="link"
            @click="handleCustomLink(scope.row, column.customLinkFun)"
          >
            {{ scope.row[column.prop] }}
          </span>
          <span v-else>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="modalClose"
      class="preview-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <!-- 技术点：一定使用v-if="dialogVisible" 不能使用v-show,否则图片展示时（假设点击的是第3张），前两张会快速的滑过-->
      <div
        v-if="dialogVisible"
        class="block"
      >
        <span
          class="el-image-viewer__btn el-image-viewer__close"
          @click="modalClose"
        >
          <i class="el-icon-error" />
        </span>
        <el-carousel
          trigger="click"
          class="imgbox"
          :autoplay="false"
          arrow="always"
          indicator-position="outside"
        >
          <el-carousel-item
            v-for="(item,index) in imagesPreview"
            :key="index"
          >
            <img
              :src="item"
              style="max-height: 100%; max-width: 100%;"
            >
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 暂无图片
import noImage from '@/assets/noImage.jpg'
export default {
  name: 'CustomTable',
  props: {
    tableColumns: {
      required: true,
      default: null,
      type: Array
    },
    tableData: {
      required: true,
      default: null,
      type: Array
    },
    tableCustomHeight: {
      required: false,
      type: String,
      default: null
    },
    isGray: {
      default: false,
      type: Boolean
    },
    showSummary: {
      default: false,
      type: Boolean
    },
    summaryMethod: {
      type: Function,
      default: null
    },
    spanMethod: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      noImage: noImage,
      dialogVisible: false, // 预览窗口是否展示，默认不展示
      downLoadFlag: true, // 下载图标展示与否，默认展示
      imagesPreview: []// 预览时根据点击的index重组的数据
    }
  },
  methods: {
    actionFun (event, row, actionName) {
      if (!actionName) actionName = 'action'
      this.$emit(actionName, row)
    },
    theme () {
      if (this.isGray) {
        return '#eeeeee'
      } else {
        return '#0076ff'
      }
    },
    /** 图片预览 */
    showImage (index, obj) {
      if (!this.downLoadFlag) {
        return false
      }
      this.imagesPreview = []
      this.dialogVisible = true
      let imgArr = obj
      let before = imgArr.slice(0, index)
      let after = imgArr.slice(index)
      this.imagesPreview = after.concat(before)
    },
    /** 点击链接  */
    handleLink (rowData) {
      this.$emit('linkMethod', rowData)
    },
    /** 自定义点击链接 */
    handleCustomLink (rowData, linkFunName) {
      this.$emit(linkFunName, rowData)
    },
    modalClose () {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  padding: 10px 0;
}
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
  }
}
::v-deep .gray-color.el-table {
  th {
    color: #000;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 0 4px;
}
::v-deep .el-link--inner {
  font-size: 12px;
  font-size: 20px;
}
.img-size {
  width: 65px;
  height: 65px;
  margin: 2px 0;
  vertical-align: middle;
  cursor: pointer;
}
.preview-dialog {
  width: 100%;
  height: 100%;
  overflow: hidden;
  ::v-deep .el-dialog {
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: transparent;
  }
  ::v-deep .el-dialog .el-dialog__body {
    margin-top: -60px;
    border-top: none;
    border-bottom: none;
  }
}
.el-carousel__item {
  text-align: center;
}

.hi-upload-file {
  width: 1200px;
  overflow: hidden;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  .img-list {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    display: flex;
    align-items: center;
    overflow: hidden;
    border: 1px solid #c0ccda;
    .el-image {
      flex: 1;
    }
  }
}
::v-deep .el-carousel__container {
  height: 100%;
}
.el-carousel--horizontal {
  overflow: hidden;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
::v-deep .el-carousel__indicators--outside {
  display: none;
}
::v-deep .el-image-viewer__btn {
  position: fixed;
  right: 20px;
  top: 10px;
}
::v-deep .el-image__inner,
.el-image__placeholder,
.el-image__error {
  height: auto;
  vertical-align: middle;
  align-items: center;
}
.img-text {
  display: flex;
  span {
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    text-align: center;
    line-height: 28px;
  }
}
.el-image-viewer__close {
  color: #fff;
  .el-icon-error:before {
    color: #fff;
  }
}
.link {
  color: #5867dd;
  cursor: pointer;
}
.link:hover {
  text-decoration: underline;
}
</style>
